import { saveAs } from 'file-saver';
import moment from 'moment';
import { Card } from 'primereact/card';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withTranslation } from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import { CustomMessages } from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import MenuItemIcon from '../components/MenuItemIcon';
import TooltipComponent from '../components/TooltipComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import AccountService from '../services/AccountService';
import ProfileService from '../services/ProfileService';
import ChangePasswordDialog from './ChangePasswordDialog';
import PartnerApiAccessDialog from './PartnerApiAccessDialog';
import ContactPersonsDialog from './ContactPersonsDialog';
import HistoryListContainer from './HistoryListContainer';
import TrustedDevicesDialog from './TrustedDevicesDialog';
import {CustomDialog} from '../components/CustomDialog';
import BannerComponent from '../components/BannerComponent';

class ProfileContainer extends BaseContainer {
    constructor(props) {
        super(props, new ProfileService());
        this.accountService = new AccountService();
        this.user = this.authService.getProfile();
        this.state = {
            balance: {},
            profileInfoLoading: true,
            contractTermsLoading: true,
            recipientAndBankNameLoading: true,
            apiAccessDataLoading: true,
            lastInvoiceAmount: {},
            loading: false,
            list: [],
            coordinate: 0,
            element: {},
            notificationEnabled: false,
            monthOpt: [],
            userOpt: [],
            contractTerms: [],
            requiredTooltipVisible: false,
            paymentTooltipVisible: false,
            marketingTooltipVisible: false,
            twoStepAuthChosen: '',
            month: {
                id: 0,
                year: new Date().getFullYear(),
                month: new Date().getMonth(),
                name: this.props.t(`months.${new Date().getMonth()}`) + ' ' + new Date().getFullYear(),
            },
            userAgreementMapForTwoStepAuth: {
                id: this.user?.userAgreementMapId,
                username: this.user?.sub
            },
            userAgreementMapForHistory: {
                id: this.user?.userAgreementMapId,
                username: this.user?.sub
            },
            changePasswordVisibile: false,
            partnerApiAccessDialogVisibile: false,
            profileInfo: {
                ebokEmails: this.user.petraEcLogins,
                contactPersons: [{ fullName: '' }],
                notificationPhoneNumbers: [{ notificationPhoneNumber: '' }],
                invoiceEmails: [{ invoiceEmail: '' }],
                notificationEmails: [{ notificationEmail: '' }],
                contactAddress: '',
                useEmail: '',
                usePhone: '',
                email: '',
                phone: '',
            },
            dialogNotificationType: undefined,
            twoStepAuthPaths: [
                { enumValue: 'PHONE', label: "Numer telefonu" },
                { enumValue: 'EMAIL', label: "Email" },
            ],
            trustedDevices: [],
            apiAccessCardVisible: false,
            apiAccessPassword: undefined,
            apiLogin: '',
            apiEmail: '',
            apiDoc: '',
            apiPartnerId: '',
            apiSupport: '',
            apiActive: undefined,
            apiBlocked: undefined,
        };
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleChangePasswordDialogShow = this.handleChangePasswordDialogShow.bind(this);
        this.handleChangePasswordDialogHide = this.handleChangePasswordDialogHide.bind(this);
        this.handlePartnerApiAccessDialogHide = this.handlePartnerApiAccessDialogHide.bind(this);
        this.handlePartnerDialogShow = this.handlePartnerDialogShow.bind(this);
        this.handleShowRequiredTooltip = this.handleShowRequiredTooltip.bind(this);
        this.handleHideRequiredTooltip = this.handleHideRequiredTooltip.bind(this);
        this.handleShowPaymentTooltip = this.handleShowPaymentTooltip.bind(this);
        this.handleHidePaymentTooltip = this.handleHidePaymentTooltip.bind(this);
        this.handleShowMarketingTooltip = this.handleShowMarketingTooltip.bind(this);
        this.handleHideMarketingTooltip = this.handleHideMarketingTooltip.bind(this);
        this.handleChangeForTwoStepAuthCard = this.handleChangeForTwoStepAuthCard.bind(this);
        this.refreshProfile = this.refreshProfile.bind(this);
    }


    componentDidMount() {
        const { t } = this.props;
        super.componentDidMount();
        this.blockUi();
        {this.checkIfDeviceAlreadyAddedToTrusted()}
        this.service
            .getProfileInfo(this.user?.userAgreementMapId)
            .then((res) => {
                this.setState((prevState) => ({
                    profileInfoLoading: false,
                    twoStepAuthChosen: res.useEmail === true ? { enumValue: 'EMAIL', label: "Email" } : 
                        res.usePhone === true ? { enumValue: 'PHONE', label: "Numer telefonu" } : { enumValue: 'NONE', label: "Brak wyboru" },
                    profileInfo: {
                        ...prevState.profileInfo,
                        notificationEmails:
                            !!res.notificationEmails && res.notificationEmails.length > 0
                                ? res.notificationEmails
                                : [{ notificationPhoneNumber: '' }],
                        notificationPhoneNumbers:
                            !!res.notificationPhoneNumbers && res.notificationPhoneNumbers.length > 0
                                ? res.notificationPhoneNumbers
                                : [{ notificationPhoneNumber: '' }],
                        //  trustedDevices: !!res.trustedDeviceList &&  res.trustedDeviceList.length >0 ? res.trustedDeviceList : [{id: '', deviceName: '', deviceNumber: ''}],
                        lastPasswordChange: res.lastPasswordChange ? new Date(res.lastPasswordChange) : undefined,
                        useEmail: res.useEmail,
                        usePhone: res.usePhone,
                        email: res.email,
                        phone: res.phone,
                    },
                }));
            })
            .catch(() => {
                this.setState({ profileInfoLoading: false });
                this.showErrorMessage(t('error.profileInfoError'));
            });
        const months = [];
        const min = 2000;
        const max = new Date().getFullYear();
        const minMonth = 0;
        const maxMonth = new Date().getMonth();
        let mothOptCount = 0;
        for (let i = max; i >= min; i--) {
            for (let j = i === max ? maxMonth : 11; j >= minMonth; j--) {
                months.push({ id: mothOptCount, name: t(`months.${j}`) + ' ' + i, month: j, year: i });
                mothOptCount++;
            }
        }
        this.setState({ monthOpt: months });
        this.setElement();
        if (this.user.userType === 'MAIN') {
            this.service
                .getUserOpt()
                .then((response) => {
                    this.setState({
                        userOpt: response
                    });
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileUserOptError'));
                });
        }
        this.service
            .getRecipientAndBankName()
            .then((response) => {
                this.setState({
                    recipientAndBankNameLoading: false,
                    paymentRecipient: response.recipient,
                });
            })
            .catch(() => {
                this.setState({ recipientAndBankNameLoading: false });
                this.showErrorMessage(t('error.profileRecipientAndBankNameError'));
            });
        this.accountService
            .getContractTerms()
            .then((response) => {
                this.setState({
                    contractTermsLoading: false,
                    contractTerms: response,
                });
            })
            .catch(() => {
                this.setState({ contractTermsLoading: false });
                this.showErrorMessage(t('error.profileContractTermsError'));
            });
        if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE')) {
            this.service
                .getTrustedDevices(this.user?.userAgreementMapId)
                .then((response) => {
                    this.setState({
                        trustedDevices: response.trustedDeviceList,
                    });
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileTrustedDevicesError'));
                })

        }

        this.service
        .getApiAccessDetails()
        .then((response) => {
            this.setState({
                apiAccessCardVisible: true,
                apiEmail: response.email,
                apiLogin: response.login,
                apiDoc: response.documentation,
                apiPartnerId: response.partnerId,
                apiSupport: response.supportEmail,
                apiActive: response.active,
                apiBlocked: response.blocked,
            });
        })
        .catch((err) => {
            if(err.errorCode === 'RESELLERS_MODULE_DISABLED'){
                this.setState({ apiAccessDataLoading: false , apiAccessCardVisible: false});
            } else {
                this.setState({ apiAccessDataLoading: false });
                this.showErrorMessage(t('error.apiAccessError'));
            }

        });

    }

    setElement() {
        const {t} = this.props;
        this.service
            .get()
            .then((element) => {
                this.updateElement(element);
            })
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.profile'));
            });
    }

    toTitleCase(str) {
        return str
            ? str
                  .toLowerCase()
                  .split(' ')
                  .map((el) => el.charAt(0).toUpperCase() + el.substring(1))
                  .join(' ')
            : str;
    }

    updateElement(element) {
        this.setState({element}, () => this.unblockUi());
    }

    handleShowRequiredTooltip() {
        this.setState({requiredTooltipVisible: true});
    }

    handleHideRequiredTooltip() {
        this.setState({requiredTooltipVisible: false});
    }
    handleShowPaymentTooltip() {
        this.setState({paymentTooltipVisible: true});
    }

    handleHidePaymentTooltip() {
        this.setState({paymentTooltipVisible: false});
    }

    handleShowMarketingTooltip() {
        this.setState({marketingTooltipVisible: true});
    }

    handleHideMarketingTooltip() {
        this.setState({marketingTooltipVisible: false});
    }


    readMessage() {
        const messageFromStorage = this.readCookie(this.getContainerListName());
        if (messageFromStorage !== undefined && messageFromStorage != null) {
            const message = JSON.parse(messageFromStorage);
            this.removeCookie(this.getContainerListName());
            if (
                message.severity !== undefined &&
                message.severity != null &&
                message.summary !== undefined &&
                message.summary != null &&
                message.detail !== undefined &&
                message.detail != null
            ) {
                this.showMessage(message.severity, message.summary, message.detail);
            }
        }
    }
    getContainerListName() {
        return 'profile-container';
    }

    checkIfDeviceAlreadyAddedToTrusted() {
        const { t } = this.props;
        if(this.readCookie('startAfterLoginCookie') === 'true' && !(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
        this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
        this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
        this.authService.getProfile().helpdeskUserRole === 'HOTLINE')){
            let currentDeviceIdent = this.authService.generateDeviceUuid();
            this.service.getTrustedDevices(this.user?.userAgreementMapId)
                .then((res) => {
                    if (res.trustedDeviceList.length > 0) {
                        if(res.trustedDeviceList.filter(d => d.deviceIdent === currentDeviceIdent).length > 0) {
                            console.log("Urzadzenie to jest na liście zaufanych. ")
                            this.setState({ addTrustedDeviceDialog: false });
                        }
                        else {
                            console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                            this.setState({ addTrustedDeviceDialog: true });
                        }
                    }  else {console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                        this.setState({ addTrustedDeviceDialog: true });}
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileTrustedDevicesError'));
                })
        }
       
    }

    handleAddToTrustedDevice() {
        let generatedDeviceUuid = this.authService.generateDeviceUuid();
        this.service
            .addTrustedDevice(generatedDeviceUuid, this.user?.userAgreementMapId)
            .then((res) => {
                if (res === true) {
                    this.showSuccessMessage("Dodano urządzenie do zaufanych");
                    this.saveCookie('startAfterLoginCookie', false);
                    this.setState({ addTrustedDeviceDialog: false });
                }
                this.refreshProfile();
            })
            .catch(() => {
                this.showErrorMessage("Nie udało się dodać urządzenia do zaufanych");
            });
    }

    renderAddToTrustedDevicesDialog(){
        let startAfterLoginCookie = false;
        if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE') &&
            this.readCookie('startAfterLoginCookie') === 'true') {
            startAfterLoginCookie = true;
        }
        return  (
            this.state.addTrustedDeviceDialog && startAfterLoginCookie === true) && <CustomDialog
            name='add-trusted-dialog'
            className='add-trusted-device'
            header="Dodawanie urządzenia do zaufanych"
            visible={this.state.addTrustedDeviceDialog}
            viewMode={'VIEW'}
            onHide={() => {
                //  this.authService.logout();
                this.saveCookie('startAfterLoginCookie', false);
                this.setState({
                    addTrustedDeviceDialog: false,
                    //renderCodeVerificationPage: true
                    //user: undefined,
                });
            }}
            closeable
        >
            <div className='codeDialog-text'>
                <label>{"W przypadku dodania urządzenia do zaufanych podawanie kodu weryfikacyjnego przy kolejnych logowaniach nie będzie wymagane."} </label>
            </div>
            <div className='col-width-auto codeBtn'>
                <ActionButton
                    label={"Dodaj"}
                    variant='blue'
                    // className='edit-blue-link'
                    handleClick={() => this.handleAddToTrustedDevice()}
                    disabled={this.state.captchaPreventAction}
                />
            </div>

        </CustomDialog>
    }

    render() {
        const {t} = this.props;

        return (
            <DivContainer colClass='container-fluid'>
                <DivContainer colClass='dashboard'>
                    <BlockUi
                        tag='div'
                        blocking={this.state.blocking || this.state.loading}
                        loader={this.loader}
                        rendered={!this.props.embedded}
                    >
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                        {this.state.dialogVisibile ? (
                            <ContactPersonsDialog
                                className='profile-dialog'
                                element={JSON.parse(JSON.stringify(this.state.profileInfo))}
                                onHide={(e) => this.handleCloseDialog(e)}
                                visible={this.state.dialogVisibile}
                                viewMode={this.state.dialogViewMode}
                                notificationType={this.state.dialogNotificationType}
                                userAgreementMapId={this.user?.userAgreementMapId}
                                beforeSave={(callBack) => {
                                    this.setState({profileInfoLoading: true}, () => callBack());
                                }}
                                afterSave={(res) =>
                                    this.handleCloseDialog(res, () => {
                                        if (res !== undefined) {
                                            this.setState((prevState) => ({
                                                profileInfoLoading: false,
                                                profileInfo: {
                                                    ...prevState.profileInfo,
                                                    notificationEmails:
                                                        !!res.notificationEmails && res.notificationEmails.length > 0
                                                            ? res.notificationEmails
                                                            : [{notificationPhoneNumber: ''}],
                                                    notificationPhoneNumbers:
                                                        !!res.notificationPhoneNumbers && res.notificationPhoneNumbers.length > 0
                                                            ? res.notificationPhoneNumbers
                                                            : [{notificationPhoneNumber: ''}],
                                                    lastPasswordChange: res.lastPasswordChange
                                                        ? new Date(res.lastPasswordChange)
                                                        : undefined,
                                                },
                                            }));
                                        }
                                    })
                                }
                                handleChange={this.handleChange}
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                showMessage={this.showMessage}
                                embedded
                                _isMounted={this._isMounted}
                            />
                        ) : null}
                        {this.state.changePasswordVisibile && !this.state.loading ? (
                            <ChangePasswordDialog
                                onHide={() => this.handleChangePasswordDialogHide()}
                                visible={this.state.changePasswordVisibile}
                                handleSuccess={(res) => {
                                    this.handleChangePasswordDialogHide(() => {
                                        this.showSuccessMessage(t('profile.changePasswordSuccess'));
                                    });
                                }}
                                handleError={(err) => {
                                    if (err?.errorCode === 'EC_CHANGE_PASSWORD_BAD_CREDENTIALS') {
                                        this.showErrorMessage(t('error.changePasswordBadCredentialsError'));
                                    } else {
                                        this.handleChangePasswordDialogHide(() => {
                                            this.showErrorMessage(t('error.changePasswordError'));
                                        });
                                    }
                                }}
                                className='change-password-dialog'
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                showMessage={this.showMessage}
                                embedded
                                _isMounted={this._isMounted}
                            />
                        ) : null}
                        {this.state.partnerApiAccessDialogVisibile && !this.state.loading ? (
                            <PartnerApiAccessDialog
                                onHide={() => this.handlePartnerApiAccessDialogHide()}
                                visible={this.state.partnerApiAccessDialogVisibile}
                                dialogType={this.state.apiAccessDialogType}
                                handleSuccess={(res) => {
                                    this.handlePartnerApiAccessDialogHide(() => {
                                        this.refreshProfile();
                                    });
                                }}
                                handleError={(err) => {
                                    if (err?.message) {
                                        this.showErrorMessage(err.message)
                                    } else {
                                        this.handlePartnerApiAccessDialogHide(() => {
                                        });
                                    }
                                }}
                                className='access-api-dialog'
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                showMessage={this.showMessage}
                                embedded
                                _isMounted={this._isMounted}
                                element={JSON.parse(JSON.stringify({ apiEmail: this.state.apiEmail }))}
                               // apiAccessPassword={()=> this.viewApiAccessPassword(()=>{})}
                                apiAccessPassword={(res)=> this.viewApiAccessPassword(res)}
                                authCodeSentBy={this.state.profileInfo.usePhone === true ? "SMS" : "EMAIL"}
                            />
                        ) : null}
                        {this.state.twoStageLoginSettingsDialog && !this.state.loading ? (
                            <ContactPersonsDialog
                                className='profile-dialog'
                                element={JSON.parse(JSON.stringify(this.state.profileInfo))}
                                onHide={(e) => this.handleCloseDialog(e)}
                                visible={this.state.twoStageLoginSettingsDialog}
                                viewMode={this.state.dialogViewMode}
                                notificationType={"TWO_STEP_AUTH_EDIT"}
                                userAgreementMapId={this.user?.userAgreementMapId}
                                beforeSave={(callBack) => {
                                    this.setState({ profileInfoLoading: true }, () => callBack());
                                }}
                                afterSave={(res) =>
                                    this.handleCloseDialog(res, () => {
                                        if (res !== undefined) {
                                            this.setState((prevState) => ({
                                                profileInfoLoading: false,
                                                twoStepAuthChosen: res.useEmail === true ? { enumValue: 'EMAIL', label: "Email" } : { enumValue: 'PHONE', label: "Numer telefonu" },
                                                profileInfo: {
                                                    ...prevState.profileInfo,

                                                    email: res.email ? res.email : undefined,
                                                    phone: res.phone ? res.phone : undefined,
                                                    useEmail: res.useEmail ? res.useEmail : undefined,
                                                    usePhone: res.usePhone ? res.usePhone : undefined,

                                                },
                                            }));
                                        }
                                    })
                                }
                                handleChange={this.handleChange}
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                showMessage={this.showMessage}
                                embedded
                                _isMounted={this._isMounted}
                            />
                        ) : null}
                        {this.state.trustedDevicesDialogVisible && (
                            <TrustedDevicesDialog
                                onHide={() => this.handleTrustedDevicesDialogHide()}
                                visible={this.state.trustedDevicesDialogVisible}
                                handleSuccess={(res) => {
                                    this.handleTrustedDevicesDialogHide(() => {
                                        this.showSuccessMessage(t('profile.successTrustedDeviceUpdate'));
                                    });
                                }}
                                handleError={(err) => {
                                    this.handleTrustedDevicesDialogHide(() => {
                                        this.showErrorMessage(t('error.trustedDevicesError'));
                                    });

                                }}
                                afterSave={(res) =>
                                    this.handleTrustedDevicesDialogHide(res, () => {
                                        this.blockUi();
                                        this.refreshProfile();
                                        this.unblockUi();
                                    })
                                }
                                className='change-password-dialog'
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                showMessage={this.showMessage}
                                embedded
                                _isMounted={this._isMounted}
                                element={JSON.parse(JSON.stringify({ trustedDeviceList: this.state.trustedDevices }))}
                            />
                        )}
                        {this.renderAddToTrustedDevicesDialog()}
                        {this.state.loading ? null : (
                            <form onSubmit={this.handleFormSubmit} noValidate>
                                {this.renderDetails()}
                            </form>
                        )}
                    </BlockUi>
                </DivContainer>
            </DivContainer>
        );
    }

    fromAgreementHeader() {
        const {t} = this.props;
        const balanceHeaderItems = [
            {
                label: t('profile.fromAgreementData'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(balanceHeaderItems);
    }

    accessToApiHeader() {
        const {t} = this.props;
        const balanceHeaderItems = [
            {
                label: t('profile.accessToApi'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(balanceHeaderItems);
    }

    renderContractTermsListHeader() {
        const {t} = this.props;
        const balanceHeaderItems = [
            {
                label: t('profile.contractTermsList'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(balanceHeaderItems);
    }

    renderClientDataHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('profile.fromClientData'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderChangePasswordHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('profile.changePasswordHeader'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_lock',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderTrustedDevicesHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: t('profile.trustedDevicesHeader'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_lock',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    renderSaleRepresentativeHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('profile.saleRepresentative'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderPaymentData() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('profile.paymentDataLabel'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_profile_wallet',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderTwoStepAuthHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='p-card-header-minheight'>
                <div className='row'>
                    {this.labelHeader({
                        label: `${t('profile.twoStepAuthHeader')}`,
                        className: '',
                        iconSvg: 'ico_dashboard_lock',
                    })}
                    {this.labelHeader({
                        label: `${t('profile.userTwoStepAuth')}:`,
                        className: '',
                        iconSvg: 'ico_dashboard_profile',
                    })}
                    <InputDropdownComponent
                        id='userAgreementMapForTwoStepAuth'
                        name='userAgreementMapForTwoStepAuth'
                        showLabel={false}
                        label=''
                        colClass='title-dropdown col-md-4'
                        value={this.state.userAgreementMapForTwoStepAuth}
                        validator={this.validator}
                        options={this.state.userOpt}
                        onChange={this.handleChangeForTwoStepAuthCard}
                        viewMode={'EDIT'}
                        optionLabel='username'
                        dataKey='id'
                        validators='not_required'
                        stateField=''
                    />
                    <hr id='line-separator' style={{ margin: '0px', background: ' #8e92a3' }} />
                </div>
            </DivContainer>
        );
    }

    handleChangeForTwoStepAuthCard(inputType, parameters, event, onAfterStateChange = () => { }, stateField) {
        this.handleChange(inputType, parameters, event, () => {
            if (event.value !== undefined) {
                this.setState(
                    { userAgreementMapForTwoStepAuth: event.value },
                    () => {
                        this.getInfoAboutTwoFactorAuthAndTrustedDevices();
                    }
                );
            } else {
                onAfterStateChange();
            }
        }, stateField);
    }

    renderNotificationHeader() {
        const {t} = this.props;
        const headerItems = [
            {
                label: t('notification.header'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_profile_wallet',
            },
        ];
        return this.prepareHeader(headerItems);
    }
    refreshProfile() {
        const { t } = this.props;
            if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE')) {
            this.service
                .getTrustedDevices(this.user?.userAgreementMapId)
                .then((response) => {
                    this.setState({
                        trustedDevices: response.trustedDeviceList,
                    });
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileTrustedDevicesError'));
                });

                this.service
                .getApiAccessDetails()
                .then((response) => {
                    this.setState({
                        apiAccessCardVisible: true,
                        apiEmail: response.email,
                        apiLogin: response.login,
                        apiDoc: response.documentation,
                        apiPartnerId: response.partnerId,
                        apiSupport: response.supportEmail,
                        apiActive: response.active,
                        apiBlocked: response.blocked,
                    });
                })
                .catch((err) => {
                    if(err.errorCode === 'RESELLERS_MODULE_DISABLED'){
                        this.setState({ apiAccessDataLoading: false , apiAccessCardVisible: false});
                    } else {
                        this.setState({ apiAccessDataLoading: false });
                        this.showErrorMessage(t('error.apiAccessError'));
                    }
                });

        }

    }
    
    getInfoAboutTwoFactorAuthAndTrustedDevices() {
        const { t } = this.props;
        if (this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE') {
            
            this.service
                .getProfileInfo(this.state.userAgreementMapForTwoStepAuth?.id)
                .then((response) => {
                    this.setState((prevState) => ({
                        profileInfoLoading: false,
                        twoStepAuthChosen: response.useEmail === true ? { enumValue: 'EMAIL', label: "Email" } : 
                            response.usePhone === true ? { enumValue: 'PHONE', label: "Numer telefonu" } : { enumValue: 'NONE', label: "Brak wyboru" },
                        profileInfo: {
                            ...prevState.profileInfo,
                            useEmail: response.useEmail,
                            usePhone: response.usePhone,
                            email: response.email,
                            phone: response.phone,
                        },
                    }));
                })
                .catch(() => {
                    this.setState({ profileInfoLoading: false });
                    this.showErrorMessage(t('error.profileInfoError'));
                });

            this.service
                .getTrustedDevices(this.state.userAgreementMapForTwoStepAuth?.id)
                .then((response) => {
                    this.setState({
                        trustedDevices: response.trustedDeviceList,
                    });
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileTrustedDevicesError'));
                })
        }
    }

    renderHistoryHeader() {
        const {t} = this.props;
        // const headerItems = [
        //     {
        //         label: t('profile.historyHeader'),
        //         type: 'LABEL',
        //         className: '',
        //         iconSvg: 'ico_history',
        //     },

        // ];
        //return this.prepareHeader(headerItems);
        return (
            <DivContainer colClass='p-card-header-minheight'>
                {/* <DivContainer colClass='col-12'> */}
                <div className='row'>
                    {this.labelHeader({
                        label: `${t('profile.historyHeader')}:`,
                        className: '',
                        iconSvg: 'ico_history',
                    })}
                    <InputDropdownComponent
                        id='month'
                        name='month'
                        showLabel={false}
                        label=''
                        colClass='title-dropdown col-md-4'
                        value={this.state.month}
                        validator={this.validator}
                        options={this.state.monthOpt}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        optionLabel='name'
                        dataKey='id'
                        validators='not_required'
                        stateField=''
                    />
                    {this.user.userType === 'MAIN' && this.labelHeader({
                        label: `${t('profile.userHistory')}:`,
                        className: '',
                        iconSvg: 'ico_dashboard_profile_white',
                    })}
                    <InputDropdownComponent
                        id='userAgreementMapForHistory'
                        name='userAgreementMapForHistory'
                        showLabel={false}
                        label=''
                        colClass='title-dropdown col-md-4'
                        value={this.state.userAgreementMapForHistory}
                        validator={this.validator}
                        options={this.state.userOpt}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        optionLabel='username'
                        dataKey='id'
                        validators='not_required'
                        stateField=''
                        rendered={this.user.userType === 'MAIN'}
                    />
                </div>
            </DivContainer>
        );
        // </DivContainer>
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    notifactionEnabledChange() {
        const {t} = this.props;
        const enabled = this.state.element.notificationEnabled;
        this.blockUi();
        this.service
            .switchNotificationEnabled()
            .then((resp) => {
                const element = this.state.element;
                element.notificationEnabled = enabled;
                this.setState({element}, () => {
                    this.showSuccessMessage(t('notification.successMessage'));
                    this.unblockUi();
                });
            })
            .catch((err) => {
                this.showErrorMessage(t('error.notificationSwitchError'));
                this.setState(
                    (prevState) => ({
                        element: {
                            ...prevState.element,
                            notificationEnabled: !enabled,
                        },
                    }),
                    () => this.unblockUi()
                );
            });
    }
    renderDetails() {
        const {apiAccessCardVisible} = this.state;
        const isAccessToApi= this.state.apiActive;
        const accessBlockedByEc = this.state.apiBlocked;
        const {t} = this.props;
        const hybridCardUser = (this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK');
        const agreementTypeValue = this.state.element.agreementType ?  this.state.element.agreementType === 'CASH' && hybridCardUser === true ? t(`AgreementType.${this.state.element.agreementType}`) +"/Hybrydowa" : t(`AgreementType.${this.state.element.agreementType}`) : '-';
        return (
            <React.Fragment>
                <DivContainer colClass='dashboard-link-container dashboard-link-container-profile '>
                    <DivContainer colClass='row'>
                        <DivContainer colClass='col-12'>
                            <Card header={this.fromAgreementHeader()}>
                                <div className='row profile'>
                                    <InputTextComponent
                                        id='contractorName'
                                        name='contractorName'
                                        label={t('profile.companyName')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.contractorName}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                    />
                                    <InputTextComponent
                                        id='tin'
                                        name='tin'
                                        label={t('profile.tin')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.tin}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                    />
                                    <InputTextComponent
                                        id='agreementAddress'
                                        name='agreementAddress'
                                        label={t('profile.agreementAddress')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.address}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                    />
                                    <InputTextComponent
                                        id='phoneNumber'
                                        name='phoneNumber'
                                        label={t('profile.phoneNumber')}
                                        colClass='col-md-4'
                                        value={this.state.element.phoneNumber}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                    />
                                    <InputTextComponent
                                        id='agreementType'
                                        name='agreementType'
                                        label={t('agreement.agreementType')}
                                        colClass='col-md-4'
                                        viewMode={'VIEW'}
                                        value={
                                           agreementTypeValue
                                        }
                                        validator={this.validator}
                                        validators=''
                                        rendered={this.user.agreementSapRole === 'FLOTA'}
                                    />
                                    <InputTextComponent
                                        id='agreementStatus'
                                        name='agreementStatus'
                                        label={t('agreement.statusLabel')}
                                        colClass='col-md-4'
                                        value={t(`EcAgreementStatus.${this.state.element.status}`)}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                    />
                                    <InputTextComponent
                                        id='invoiceDueDays'
                                        name='invoiceDueDays'
                                        label={t('profile.invoiceDueDays')}
                                        colClass='col-md-4'
                                        value={this.state.element.invoiceDueDays}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                        rendered={this.state.element.agreementType === 'CASHLESS'}
                                    />
                                    <InputTextComponent
                                        id='invoiceCycles'
                                        name='invoiceCycles'
                                        label={t('profile.invoiceCycles')}
                                        colClass='col-md-4'
                                        value={this.state.element.invoiceFrequency}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                        rendered={this.user.agreementSapRole === 'FLOTA'}
                                    />
                                    <InputTextComponent
                                        id='invoiceType'
                                        name='invoiceType'
                                        label={t('autoRegistration.invoiceType')}
                                        colClass='col-md-4'
                                        value={this.state.element.invoiceType ? t(`EcProfileInvoiceType.${this.state.element.invoiceType}`) : '-'}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                    />
                                </div>
                            </Card>
                        </DivContainer>

                        {apiAccessCardVisible && this.user.userType === 'MAIN' ?
                          <DivContainer colClass='col-12'>
                          <Card header={this.accessToApiHeader()}>
                              <BlockUi
                                  tag='div'
                                  blocking={this.state.profileInfoLoading}
                                  loader={this.loader}
                                  loaderType='small-loader'
                                  horizontal
                              >
                                 { accessBlockedByEc ?

                                 <div className={'api-access-banner'}>
                                   <BannerComponent
                                      key={'header-banner'}
                                      label={t('profile.apiBlocked')}
                                      iconSvg='ico_red_banner_alert_icon'
                                      iconSide='left'
                                      rendered={true}
                                      variant='red-banner'
                                      ignoreRightIconItems

                                  ></BannerComponent>


                                   </div> : null}

                                     <div className='row profile'>
                                         <InputTextComponent
                                             id='apiInfo'
                                             name='apiInfo'
                                             label={t('profile.apiInfo')}
                                             colClass='col-xl-10 col-lg-10 col-md-12 col-sm-12'
                                             //value={this.state.element?.apiInfo?.text}
                                             value={"Poniżej znajdują się informacje umożliwiające uruchomienie usługi."}
                                             viewMode={'VIEW'}
                                             validator={this.validator}
                                             validators=''
                                         />

                                     </div>
                                    {
                                        isAccessToApi ? null : <span>Brak dostępu do API</span>
                                    }
                                         {/* {this.user.agreementSapRole !== 'HURT' &&
                                      this.user.agreementSapRole !== 'FRANCZYZA' &&
                                      this.user.agreementSapRole !== 'HURT EPT'  &&  */}
                                         {isAccessToApi === true ? (
                                             <div className='row profile-notifications'>
                                                 {/* <div className="profile-notification-subheader">
                                              <div className='tooltip-label notifications-tip' >
                                              </div>

                                          </div> */}

                                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{ margin: '0px' }}>{t('profile.apiUsername')}</label>
                                                     <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>

                                                         <div
                                                             className='row'
                                                             key={`api-access-username`}
                                                         >
                                                             <InputTextComponent
                                                                 id={`apiLogin`}
                                                                 name='apiLogin'
                                                                /// label={"apiLogin"}
                                                                 colClass='col-12'
                                                                 value={this.state.apiLogin}
                                                                 viewMode={this.state.viewMode}
                                                                 showLabel={false}
                                                                 validator={this.validator}
                                                                 validators=''
                                                             />
                                                         </div>

                                                     </div>

                                                 </div>
                                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{ margin: '0px' }}>{t('profile.apiPassword')}</label>
                                                     <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                         <div
                                                             className='row'
                                                             key={`notification-email-index}-$notificationEmail?.address}`}
                                                         >
                                                             <InputTextComponent
                                                                 id='apiAccessPassword'
                                                                 name='apiAccessPassword'
                                                                 colClass='col-width-auto'
                                                                 value={this.state.apiAccessPassword}
                                                                 viewMode={'VIEW'}
                                                                 renderValue={() => {
                                                                     return (
                                                                         <span>
                                                                             {this.state.apiAccessPassword !== undefined ? this.state.apiAccessPassword : "********** "}
                                                                             <ActionLink
                                                                                 label={t(this.props.label)}
                                                                                 handleClick={() => this.handlePartnerDialogShow('CODE_VERIFICATION')}
                                                                                 variant='blue'
                                                                                 iconName='mdi-eye'
                                                                                 iconSide='left'
                                                                                 iconSize='m'
                                                                                 iconColor='blue'
                                                                                 disabled={this.state.apiAccessPassword !== undefined ? true : false}
                                                                             />
                                                                         </span>
                                                                     );
                                                                 }}
                                                             />
                                                         </div>
                                                     </div>
                                                 </div>

                                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{ margin: '0px' }}>{t('profile.apiEmail')}</label>
                                                     <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>

                                                         <InputTextComponent
                                                             id='apiEmail'
                                                             name='apiEmail'
                                                             showLabel={false}
                                                             colClass='col-width-auto'
                                                             value={this.state.apiEmail}
                                                             viewMode={'VIEW'}
                                                             disabled={true}
                                                             renderValue={() => {
                                                                 return (
                                                                     <span style={{display:'flex'}}>
                                                                         {this.state.apiEmail}
                                                                         <ActionLink
                                                                             label={t(this.props.label)}
                                                                             handleClick={() => this.handlePartnerDialogShow('EDIT_EMAIL')}
                                                                             variant='blue'
                                                                             iconName='mdi-pencil'
                                                                             iconSide='left'
                                                                             iconSize='m'
                                                                             iconColor='blue'
                                                                             disabled={false}
                                                                         />
                                                                     </span>
                                                                 );
                                                             }}
                                                         />
                                                     </div>

                                                 </div>

                                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{ margin: '0px' }}>{t('profile.apiDoc')}</label>
                                                     <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>


                                                         <div
                                                             className='row'
                                                             key={`notification-email-{index}-{notificationEmail?gddress}`}
                                                         >
                                                             <InputTextComponent
                                                                 id='apiDoc'
                                                                 name='apiDoc'
                                                                 colClass='col-width-auto'
                                                                 value={this.state.apiDoc}
                                                                 viewMode={'VIEW'}
                                                                 renderValue={() => {
                                                                     return (
                                                                         <span>
                                                                            {this.state.apiDoc !== null && this.state.apiDoc !== "" ?  <a href={this.state.apiDoc} target="_blank">{"Dokumentacja"}</a> : "Brak dokumentacji" }
                                                                         </span>
                                                                     );
                                                                 }}
                                                             />
                                                         </div>

                                                     </div>
                                                 </div>
                                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{ margin: '0px' }}>{t('profile.apiPartnerId')}</label>
                                                     <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                         <div
                                                             className='row'
                                                             key={`apiPartnerId-key`}
                                                         >
                                                             <InputTextComponent
                                                                 id={'apiPartnerId'}
                                                                 name='apiPartnerId'
                                                                 colClass='col-12'
                                                                 value={this.state.apiPartnerId}
                                                                 viewMode={this.state.viewMode}
                                                                 showLabel={false}
                                                                 validator={this.validator}
                                                                 validators=''
                                                             />
                                                         </div>
                                                     </div>

                                                 </div>
                                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{ margin: '0px' }}>{t('profile.apiSupport')}</label>
                                                     <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                        <div
                                                            className='row'
                                                            key={`apiSupport-div`}
                                                        >
                                                            <InputTextComponent
                                                                id={`apiSupport`}
                                                                name='apiSupport'
                                                                colClass='col-12'
                                                                value={this.state.apiSupport}
                                                                stateField={`apiSupport`}
                                                                viewMode={this.state.viewMode}
                                                                showLabel={false}
                                                                validator={this.validator}
                                                                validators=''
                                                            />
                                                        </div>
                                                     </div>
                                                 </div>
                                             </div>
                                         ) : null}
                                         <div className='col-12 profile edit'>
                                             <div className='col-xl-10 col-lg-8 col-md-8 col-sm-12'> </div>
                                             <ActionButton
                                                 label={isAccessToApi ? t('profile.apiAccessResignation') : t('profile.apiAccessRequest')}
                                                 variant='btn-api-access white'
                                                 handleClick={(e) => isAccessToApi ?
                                                    this.handlePartnerDialogShow('API_RESIGNATION') :
                                                    this.handlePartnerDialogShow('API_ACCESS')
                                                 }
                                                 iconSvg='ico_right_arrow'
                                                 iconSide='left'
                                                 disabled={this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                                             />
                                         </div>
                                     </BlockUi>
                                 </Card>
                             </DivContainer> : null
                        }





                        <DivContainer colClass='col-12' rendered={!!this.state.contractTerms && this.state.contractTerms.length > 0}>
                            <Card header={this.renderContractTermsListHeader()}>
                                <BlockUi
                                    tag='div'
                                    blocking={this.state.contractTermsLoading}
                                    loader={this.loader}
                                    loaderType='small-loader'
                                    horizontal
                                >
                                    <div className='row profile'>
                                        <div className='col-12'>
                                            <div className='row'>
                                                <div className='col-md-12 form-group'>
                                                    <label id={`contract-terms-label-id`} className='p-label'>
                                                        {t('profile.contractTermsList')}
                                                    </label>
                                                    {!!this.state.contractTerms
                                                        ? this.state.contractTerms.map((ct, i) => (
                                                              <div className='col-12' key={`contract-terms-${i}`}>
                                                                  <ActionLink
                                                                      label={ct.displayName}
                                                                      //   iconSvg='ico_download_link_icon'
                                                                      variant='contract-terms-pdf'
                                                                      handleClick={(e) => {
                                                                          e.preventDefault();
                                                                          this.accountService
                                                                              .getContractTermsFile(ct.fileName)
                                                                              .then((response) => {
                                                                                const displayFileName = ct.displayName + ".pdf";
                                                                                  saveAs(response, displayFileName);
                                                                              })
                                                                              .catch(() => {
                                                                                  this.showErrorMessage(
                                                                                      t('profile.contractTermsFileError')
                                                                                  );
                                                                              });
                                                                      }}
                                                                      key={'download-invoice-button'}
                                                                  />
                                                              </div>
                                                          ))
                                                        : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </BlockUi>
                            </Card>
                        </DivContainer>
                        <DivContainer colClass='col-12'>
                            <Card header={this.renderClientDataHeader()}>
                                <BlockUi
                                    tag='div'
                                    blocking={this.state.profileInfoLoading}
                                    loader={this.loader}
                                    loaderType='small-loader'
                                    horizontal
                                >
                                    <React.Fragment>
                                        <div className='row profile'>
                                            <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>                                         
                                            <div className="profile-notification-subheader">
                                                    <div> <span >{t('profile.login-address-header')}</span> </div>
                                                </div>
                                                {this.state.profileInfo.ebokEmails && this.state.profileInfo.ebokEmails.length
                                                    ? this.state.profileInfo.ebokEmails.map((ebokEmail, index) => {
                                                          return (
                                                              <div className='row' key={`ebok-email-${ebokEmail?.address}`}>
                                                                  <InputTextComponent
                                                                      id='ebokEmail'
                                                                      name='ebokEmail'
                                                                      label={t('profile.ebokEmail')}
                                                                      colClass='col-12'
                                                                      value={ebokEmail}
                                                                      stateField={`profileInfo.ebokEmails[${index}]`}
                                                                      viewMode={this.state.viewMode}
                                                                     // showLabel={index === 0}
                                                                      validator={this.validator}
                                                                      validators=''
                                                                  />
                                                              </div>
                                                          );
                                                      })
                                                    : null}
                                                    </div>   
                                                    {this.user.agreementSapRole !== 'HURT' &&
                                            this.user.agreementSapRole !== 'FRANCZYZA' &&
                                            this.user.agreementSapRole !== 'HURT EPT' ? (
                                                <div className='col-12 profile edit'>
                                                    <ActionButton
                                                        label={t('details.editButton')}
                                                        variant='editButton white'
                                                        handleClick={(e) => this.handleOpenDialog(e,'REQUIRED_NOTIFICATION')}
                                                        iconSvg='ico_pencil'
                                                        iconSide='left'
                                                        disabled ={true}
                                                        
                                                    />
                                                </div>
                                            ) : null}                   
                                  
                                            {this.user.agreementSapRole !== 'HURT' &&
                                            this.user.agreementSapRole !== 'FRANCZYZA' &&
                                            this.user.agreementSapRole !== 'HURT EPT' ? (
                                            <div className='row profile-notifications'>
                                            <div  className="profile-notification-subheader">
                                                <div className='tooltip-label notifications-tip' > 
                                                <span className='header-notification'> {t('profile.required-notification-header')} </span>  
                                             
                                                <TooltipComponent
                                            id='start-tooltip-label-req'
                                            key='start-tooltip-label-req'
                                            visible={this.state.requiredTooltipVisible}
                                            content={t('profile.tooltipRequired')}
                                            eventListeners={[
                                                {
                                                    eventName: 'mouseleave',
                                                    fnc: this.handleHideRequiredTooltip,
                                                    eventElementId: 'ico_help_notification-required',
                                                },
                                                {
                                                    eventName: 'mouseenter',
                                                    fnc: this.handleShowRequiredTooltip,
                                                    eventElementId: 'ico_help_notification-required',
                                                },
                                            ]}
                                        />
                                                <MenuItemIcon
                                                    alt=''
                                                    key={'menu-item-key-req'}
                                                    id='ico_help_notification-required'
                                                    className='icon-svg right-label '
                                                    iconSvg={'ico_help_input_label_blue'}
                                                    eventListeners={[
                                                        {
                                                            eventName: 'mouseenter',
                                                            fnc: this.handleShowRequiredTooltip,
                                                            eventElementId: 'ico_help_notification-required',
                                                        },
                                                    ]}
                                                />
                                              
                                                
                                                 </div>
                                                
                                                </div>

                                                    <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                        <label className='p-label' style={{ margin: '0px' }}>{t('profile.notificationPhoneNumber')}</label>
                                                        <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                  
                                                  {this.state.profileInfo.notificationPhoneNumbers &&
                                                  this.state.profileInfo.notificationPhoneNumbers.length
                                                      ? this.state.profileInfo.notificationPhoneNumbers.map((notificationPhoneNumber, index) => {
                                                              if(notificationPhoneNumber.notificationTypeTranslated === 'REQUIRED_NOTIFICATION')
                                                                {return (
                                                                    <div
                                                                        className='row'
                                                                        key={`notification-phone-number-${index}-${notificationPhoneNumber?.address}`}
                                                                    >
                                                                        <InputTextComponent
                                                                            id={`${index}-notificationPhoneNumber`}
                                                                            name='notificationPhoneNumber'
                                                                            label={t('profile.notificationPhoneNumber')}
                                                                            colClass='col-12'
                                                                            value={notificationPhoneNumber?.address}
                                                                            stateField={`profileInfo.notificationPhoneNumbers[${index}]`}
                                                                            viewMode={this.state.viewMode}
                                                                            //showLabel={index === 0}
                                                                            showLabel={false}
                                                                            validator={this.validator}
                                                                            validators=''
                                                                        />
                                                                    </div>
                                                                );} else return null;
                                                            }
                                                        )
                                                      : null}
                                              </div>

                                                </div> 
                                                <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                         <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationEmail')}</label>
                                                         <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>

                                                {this.state.profileInfo.notificationEmails &&
                                                this.state.profileInfo.notificationEmails.length
                                                    ? this.state.profileInfo.notificationEmails.map((notificationEmail, index) => {
                                                        if(notificationEmail.notificationTypeTranslated === 'REQUIRED_NOTIFICATION')
                                                        {  return (
                                                              <div
                                                                  className='row'
                                                                  key={`notification-email-${index}-${notificationEmail?.address}`}
                                                              >
                                                                  <InputTextComponent
                                                                      id={`${index}-notificationEmail`}
                                                                      name='notificationEmail'
                                                                      label={t('profile.notificationEmail')}
                                                                      colClass='col-12'
                                                                      value={notificationEmail?.address}
                                                                      stateField={`profileInfo.notificationEmails[${index}]`}
                                                                      viewMode={this.state.viewMode}
                                                                      //showLabel={index === 0}
                                                                      showLabel={false}
                                                                      validator={this.validator}
                                                                      validators=''
                                                                  />
                                                              </div>
                                                          );} else return null;
                                                      })
                                                    : null}
                                            </div>
                                                </div>
                                            </div> ) : null }
                                            {this.user.agreementSapRole !== 'HURT' &&
                                            this.user.agreementSapRole !== 'FRANCZYZA' &&
                                            this.user.agreementSapRole !== 'HURT EPT' ? (
                                                <div className='col-12 profile edit'>
                                                    <ActionButton
                                                        label={t('details.editButton')}
                                                        variant='editButton white'
                                                        handleClick={(e) => this.handleOpenDialog(e,'REQUIRED_NOTIFICATION')}
                                                        iconSvg='ico_pencil'
                                                        iconSide='left'
                                                        disabled={(this.user?.agreementSapRole === 'FLOTA' && !this.isUserHasPermission('PERMISSION_EDIT_PROFILE')) || 
                                                            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                                                    />
                                                </div>
                                            ) : null}
                                                    
                                            {this.authService.getProfile().agreementType !== 'CASH' &&
                                             this.user.agreementSapRole !== 'HURT' &&
                                             this.user.agreementSapRole !== 'FRANCZYZA' &&
                                             this.user.agreementSapRole !== 'HURT EPT'
                                            ?
                                             <div className='row profile-notifications'>
                                             <div className="profile-notification-subheader">
                                             <div className='tooltip-label notifications-tip' >
                                                      <span className='header-notification'>{t('profile.payment-notification-header')}</span>
                                                      <TooltipComponent
                                            id='start-tooltip-label-payment'
                                            key='start-tooltip-label-payment'
                                            visible={this.state.paymentTooltipVisible}
                                            content={t('profile.tooltipPayment')}
                                            eventListeners={[
                                                {
                                                    eventName: 'mouseleave',
                                                    fnc: this.handleHidePaymentTooltip,
                                                    eventElementId: 'ico_help_notification-payment',
                                                },
                                                {
                                                    eventName: 'mouseenter',
                                                    fnc: this.handleShowPaymentTooltip,
                                                    eventElementId: 'ico_help_notification-payment',
                                                },
                                            ]}
                                        />
                                                      <MenuItemIcon
                                                     alt=''
                                                     key={'menu-item-key-pay'}
                                                     id='ico_help_notification-payment'
                                                     className='icon-svg right-label '
                                                     iconSvg={'ico_help_input_label_blue'}
                                                     eventListeners={[
                                                         {
                                                             eventName: 'mouseenter',
                                                             fnc: this.handleShowPaymentTooltip,
                                                             eventElementId: 'ico_help_notification-payment',
                                                         },
                                                     ]}
                                                 />
                                                 </div>
                                                 </div>
                                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationPhoneNumber')}</label>
                                                     {this.state.profileInfo.notificationPhoneNumbers &&
                                                     this.state.profileInfo.notificationPhoneNumbers.length
                                                         ? this.state.profileInfo.notificationPhoneNumbers.map( (notificationPhoneNumber, index) => {
                                                                 if(notificationPhoneNumber.notificationTypeTranslated === 'PAYMENT_NOTIFICATION')
                                                                   {return (
                                                                       <div
                                                                           className='row'
                                                                           key={`notification-phone-number-${index}-${notificationPhoneNumber?.address}`}
                                                                       >
                                                                           <InputTextComponent
                                                                               id={`${index}-notificationPhoneNumber`}
                                                                               name='notificationPhoneNumber'
                                                                              // label={t('profile.notificationPhoneNumber')}
                                                                               colClass='col-12'
                                                                               value={notificationPhoneNumber?.address}
                                                                               stateField={`profileInfo.notificationPhoneNumbers[${index}]`}
                                                                               viewMode={this.state.viewMode}
                                                                               //showLabel={index === 0}
                                                                               showLabel={false}
                                                                               validator={this.validator}
                                                                               validators=''
                                                                           />
                                                                       </div>
                                                                   );} else return null;
                                                               }
                                                           )
                                                         : null}
                                                 </div>
                                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationEmail')}</label>
                                                     {this.state.profileInfo.notificationEmails &&
                                                     this.state.profileInfo.notificationEmails.length
                                                         ? this.state.profileInfo.notificationEmails.map((notificationEmail, index) => {
                                                             if(notificationEmail.notificationTypeTranslated === 'PAYMENT_NOTIFICATION')
                                                             {  return (
                                                                   <div
                                                                       className='row'
                                                                       key={`notification-email-${index}-${notificationEmail?.address}`}
                                                                   >
                                                                       <InputTextComponent
                                                                           id={`${index}-notificationEmail`}
                                                                           name='notificationEmail'
                                                                          // label={t('profile.notificationEmail')}
                                                                           colClass='col-12'
                                                                           value={notificationEmail?.address}
                                                                           stateField={`profileInfo.notificationEmails[${index}]`}
                                                                           viewMode={this.state.viewMode}
                                                                          // showLabel={index === 0}
                                                                          showLabel={false}
                                                                           validator={this.validator}
                                                                           validators=''
                                                                       />
                                                                   </div>
                                                               );} else return null;
                                                           })
                                                         : null}
                                                 </div>
            
                                           
 
                                             </div> : null 
                                            }
                                           
                                            {this.authService.getProfile().agreementType !== 'CASH' &&
                                            this.user.agreementSapRole !== 'HURT' &&
                                            this.user.agreementSapRole !== 'FRANCZYZA' &&
                                            this.user.agreementSapRole !== 'HURT EPT' ? (
                                                <div className='col-12 profile edit'>
                                                    <ActionButton
                                                        label={t('details.editButton')}
                                                        variant='editButton white'
                                                        handleClick={(e) => this.handleOpenDialog(e,'PAYMENT_NOTIFICATION')}
                                                        iconSvg='ico_pencil'
                                                        iconSide='left'
                                                        disabled={(this.user?.agreementSapRole === 'FLOTA' && !this.isUserHasPermission('PERMISSION_EDIT_PROFILE')) || 
                                                            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                                                    />
                                                </div>
                                            ) : null}

                                            {this.user.agreementSapRole !== 'HURT' &&
                                            this.user.agreementSapRole !== 'FRANCZYZA' &&
                                            this.user.agreementSapRole !== 'HURT EPT' ? (
                                            <div className='row profile-notifications'>
                                            <div className="profile-notification-subheader">
                                            <div className='tooltip-label notifications-tip' > 
                                                     <span className='header-notification'> {t('profile.marketing-notification-header')}</span>
                                                     <TooltipComponent
                                            id='start-tooltip-label-marketing'
                                            key='start-tooltip-label-marketing'
                                            visible={this.state.marketingTooltipVisible}
                                            content={t('profile.tooltipMarketing')}
                                            eventListeners={[
                                                {
                                                    eventName: 'mouseleave',
                                                    fnc: this.handleHideMarketingTooltip,
                                                    eventElementId: 'ico_help_notification-marketing',
                                                },
                                                {
                                                    eventName: 'mouseenter',
                                                    fnc: this.handleShowMarketingTooltip,
                                                    eventElementId: 'ico_help_notification-marketing',
                                                },
                                            ]}
                                        />
                                                     <MenuItemIcon
                                                    alt=''
                                                    key={'menu-item-key-mark'}
                                                    id='ico_help_notification-marketing'
                                                    className='icon-svg right-label '
                                                    iconSvg={'ico_help_input_label_blue'}
                                                    eventListeners={[
                                                        {
                                                            eventName: 'mouseenter',
                                                            fnc: this.handleShowMarketingTooltip,
                                                            eventElementId: 'ico_help_notification-marketing',
                                                        },
                                                    ]}
                                                /></div>
                                                </div>
                                                <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                   <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationPhoneNumber')}</label>
                                                    {this.state.profileInfo.notificationPhoneNumbers &&
                                                    this.state.profileInfo.notificationPhoneNumbers.length
                                                        ? this.state.profileInfo.notificationPhoneNumbers.map((notificationPhoneNumber, index) => {
                                                                if(notificationPhoneNumber.notificationTypeTranslated === 'MARKETING_NOTIFICATION')
                                                                  {return (
                                                                      <div
                                                                          className='row'
                                                                          key={`notification-phone-number-${index}-${notificationPhoneNumber?.address}`}
                                                                      >
                                                                          <InputTextComponent
                                                                              id={`${index}-notificationPhoneNumber`}
                                                                              name='notificationPhoneNumber'
                                                                              //label={t('profile.notificationPhoneNumber')}
                                                                              colClass='col-12'
                                                                              value={notificationPhoneNumber?.address}
                                                                              stateField={`profileInfo.notificationPhoneNumbers[${index}]`}
                                                                              viewMode={this.state.viewMode}
                                                                              //showLabel={index === 0}
                                                                              showLabel={false}
                                                                              validator={this.validator}
                                                                              validators=''
                                                                          />
                                                                      </div>
                                                                  );} else return null;
                                                              }
                                                          )
                                                        : null}
                                                </div>
                                                <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                     <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationEmail')}</label>
                                                    {this.state.profileInfo.notificationEmails &&
                                                    this.state.profileInfo.notificationEmails.length
                                                        ? this.state.profileInfo.notificationEmails.map((notificationEmail, index) => {
                                                            if(notificationEmail.notificationTypeTranslated === 'MARKETING_NOTIFICATION')
                                                            {  return (
                                                                  <div
                                                                      className='row'
                                                                      key={`notification-email-${index}-${notificationEmail?.address}`}
                                                                  >
                                                                      <InputTextComponent
                                                                          id={`${index}-notificationEmail`}
                                                                          name='notificationEmail'
                                                                          //label={t('profile.notificationEmail')}
                                                                          colClass='col-12'
                                                                          value={notificationEmail?.address}
                                                                          stateField={`profileInfo.notificationEmails[${index}]`}
                                                                          viewMode={this.state.viewMode}
                                                                        //  showLabel={index === 0}
                                                                          validator={this.validator}
                                                                          validators=''
                                                                      />
                                                                  </div>
                                                              );} else return null;
                                                          })
                                                        : null}
                                                </div>

                                            
                                            </div>
                                            ) : null }
                                            {this.user.agreementSapRole !== 'HURT' &&
                                            this.user.agreementSapRole !== 'FRANCZYZA' &&
                                            this.user.agreementSapRole !== 'HURT EPT' ? (
                                                <div className='col-12 profile edit'>
                                                    <ActionButton
                                                        label={t('details.editButton')}
                                                        variant='editButton white'
                                                        handleClick={(e) => this.handleOpenDialog(e,'MARKETING_NOTIFICATION')}
                                                        iconSvg='ico_pencil'
                                                        iconSide='left'
                                                        disabled={(this.user?.agreementSapRole === 'FLOTA' && !this.isUserHasPermission('PERMISSION_EDIT_PROFILE')) || 
                                                            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                                                    />
                                                </div>
                                            ) : null}
                                            {/* dwuetapowe logowanie */}

                                            {(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
                                                this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
                                                this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
                                                this.authService.getProfile().helpdeskUserRole === 'HOTLINE') ? null :

                                                <div className='row profile-notifications'>
                                                    <div className="profile-notification-subheader">
                                                        <div className='tooltip-label notifications-tip' >
                                                            <span className='header-notification'> {t('profile.two-part-login-header')}</span>

                                                        </div>
                                                    </div>
                                                            <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                                <div
                                                                    className='row'
                                                                    key={`2-step-auth-phone`}
                                                                >
                                                                    <InputTextComponent
                                                                        id={`$2stepAuthPhone`}
                                                                        name='phone'
                                                                        label={t('profile.notificationPhoneNumber')}
                                                                        colClass='col-12'
                                                                        value={this.state.profileInfo.phone}
                                                                        stateField={`profileInfo.phone`}
                                                                        viewMode={this.state.viewMode}
                                                                        //showLabel={index === 0}
                                                                        showLabel={true}
                                                                        validator={this.validator}
                                                                        validators=''
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                                <div
                                                                    className='row'
                                                                    key={`2-step-auth-phone`}
                                                                >
                                                                    <InputTextComponent
                                                                        id={`$2stepAuthEmail`}
                                                                        name='email'
                                                                        label={t('profile.notificationEmail')}
                                                                        colClass='col-12'
                                                                        value={this.state.profileInfo.email}
                                                                        stateField={`profileInfo.phone`}
                                                                        viewMode={this.state.viewMode}
                                                                        //showLabel={index === 0}
                                                                        showLabel={true}
                                                                        validator={this.validator}
                                                                        validators=''
                                                                    />
                                                                </div>
                                                            </div>

                                                            <InputRadioButtonComponent
                                                                id={`twoStepAuthChosen-type`}
                                                                name='type'
                                                                colClass='col-12 card-manage-limits'
                                                                options={this.state.twoStepAuthPaths}
                                                                value={this.state.twoStepAuthChosen}
                                                                valueLabel='label'
                                                                labelOnRight
                                                                itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                                                                onChange={this.handleChange}
                                                                showLabel={true}
                                                                validator={this.validator}
                                                                validators='required'
                                                                label={"Wykorzystaj "}
                                                                viewMode={'VIEW'}
                                                                rendered={this.props.viewMode === 'VIEW'}
                                                                valueKey='enumValue'
                                                                stateField={`twoStepAuthChosen`}
                                                            />
                                                </div>
                                            }

                                            { !(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
                                                    this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
                                                    this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
                                                    this.authService.getProfile().helpdeskUserRole === 'HOTLINE') ? (
                                                <div className='col-12 profile edit'>
                                                    <ActionButton
                                                        label={t('details.editButton')}
                                                        variant='editButton white'
                                                        handleClick={(e) => this.handleChangeTwoStageLoginSettingsDialogShow(e)}
                                                        iconSvg='ico_pencil'
                                                        iconSide='left'
                                                    />
                                                </div>
                                            ) : null}

                                            {/* dwuetapowe logowanie */}

                                        </div>
                                    </React.Fragment>
                                </BlockUi>
                            </Card>
                        </DivContainer>
                        <DivContainer colClass='col-12'>
                            <Card header={this.renderChangePasswordHeader()}>
                                <BlockUi
                                    tag='div'
                                    blocking={this.state.profileInfoLoading}
                                    loader={this.loader}
                                    loaderType='small-loader'
                                    horizontal
                                >
                                    <div className='row m-0 profile change-password'>
                                        <span className='change-password-span col-8 p-0'>
                                            {t('profile.lastPasswordChange')}{' '}
                                            {!!this.state.profileInfo.lastPasswordChange
                                                ? moment(this.state.profileInfo.lastPasswordChange).format('DD.MM.YYYY, HH:mm:ss')
                                                : '-'}
                                        </span>
                                        <ActionButton
                                            label={t('profile.changePasswordButton')}
                                            variant='change-password-button white'
                                            handleClick={this.handleChangePasswordDialogShow}
                                            iconSvg='ico_right_arrow'
                                            iconSide='left'
                                            disabled={(this.user?.agreementSapRole === 'FLOTA' && !this.isUserHasPermission('PERMISSION_EDIT_PROFILE')) ||
                                                this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER'}
                                        />
                                    </div>
                                </BlockUi>
                            </Card>
                        </DivContainer>
                        {(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
                            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
                            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
                            this.authService.getProfile().helpdeskUserRole === 'HOTLINE') ? null :

                            <DivContainer colClass='col-12'>
                                <Card header={this.renderTrustedDevicesHeader()}>
                                    <BlockUi
                                        tag='div'
                                        blocking={this.state.profileInfoLoading}
                                        loader={this.loader}
                                        loaderType='small-loader'
                                        horizontal
                                    >
                                        <div className='row m-0 profile change-password'>
                                            <div className='col-xl-8 col-lg-8 col-md-8 col-sm-12'>
                                                <label className='p-label' style={{ margin: '0px' }}>{"Urządzenie "}</label>
                                                {this.state.trustedDevices &&
                                                    this.state.trustedDevices.length > 0
                                                    ? this.state.trustedDevices?.map((trustedDevice, index) => {

                                                        {
                                                            return (
                                                                <div
                                                                    className='row'
                                                                    key={`trustedDevice-${index}-${trustedDevice?.deviceIdent}`}
                                                                >
                                                                    <InputTextComponent
                                                                        id={`${index}-trustedDevice`}
                                                                        name='trustedDevice'
                                                                        //label={t('profile.notificationEmail')}
                                                                        colClass='col-12'
                                                                        value={trustedDevice?.deviceIdent + " (" + trustedDevice?.deviceName + ")"}
                                                                        stateField={`trustedDevice[${index}]`}
                                                                        // viewMode={this.state.viewMode}
                                                                        // showLabel={index === 0}
                                                                        validator={this.validator}
                                                                        validators=''
                                                                    />

                                                                </div>
                                                            );
                                                        }
                                                    })
                                                    : null}
                                            </div>

                                            <ActionButton
                                                label={t('details.editButton')}
                                                variant='change-password-button white'
                                                handleClick={(e) => this.handleTrustedDevicesDialogShow(e)}
                                                iconSvg='ico_right_arrow'
                                                iconSide='left'
                                            />
                                        </div>
                                    </BlockUi>
                                </Card>
                            </DivContainer>

                        }

                        <DivContainer colClass='col-12'>
                            <Card header={this.renderSaleRepresentativeHeader()}>
                                <div className='row profile'>
                                    <InputTextComponent
                                        id='firstSaleRepresentative'
                                        name='firstSaleRepresentative'
                                        label={t('profile.agreementSaleRepName')}
                                        colClass='col-md-4'
                                        value={this.toTitleCase(this.user.agreementSaleRepName)}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                    />
                                    <InputTextComponent
                                        id='agreementSaleRepEmail'
                                        name='agreementSaleRepEmail'
                                        label={t('profile.agreementSaleRepEmail')}
                                        colClass='col-md-4'
                                        viewMode={'VIEW'}
                                        value={this.user.agreementSaleRepEmail}
                                        validator={this.validator}
                                        validators=''
                                    />
                                    <InputTextComponent
                                        id='agreementSaleRepPhone'
                                        name='agreementSaleRepPhone'
                                        label={t('profile.agreementSaleRepPhone')}
                                        colClass='col-md-4'
                                        value={this.user.agreementSaleRepPhoneNumber}
                                        viewMode={'VIEW'}
                                        validator={this.validator}
                                        validators=''
                                    />
                                </div>
                            </Card>
                        </DivContainer>
                        {this.state.element.agreementType !== 'CASH' ? (
                            <DivContainer colClass='col-12'>
                                <Card header={this.renderPaymentData()}>
                                    <BlockUi
                                        tag='div'
                                        blocking={this.state.recipientAndBankNameLoading}
                                        loader={this.loader}
                                        loaderType='small-loader'
                                        horizontal
                                    >
                                        <div className='row profile'>
                                            <InputTextComponent
                                                id='paymentRecipient'
                                                name='paymentRecipient'
                                                label={t('profile.paymentRecipient')}
                                                colClass='col-md-4'
                                                value={this.state.paymentRecipient}
                                                viewMode={'VIEW'}
                                                validator={this.validator}
                                                validators=''
                                            />
                                            <InputTextComponent
                                                id='agreementBankAccountNumber'
                                                name='agreementBankAccountNumber'
                                                label={t('profile.bankAccount')}
                                                colClass='col-md-4'
                                                viewMode={'VIEW'}
                                                value={this.user.agreementBankAccountNumber}
                                                validator={this.validator}
                                                validators=''
                                                renderValue={() => {
                                                    return (
                                                        <div className='bank-name-and-account'>
                                                            <span>{this.user.agreementBankAccountNumber}</span>
                                                            <CopyToClipboard
                                                                text={
                                                                    !!this.user.agreementBankAccountNumber
                                                                        ? this.user.agreementBankAccountNumber.replace(/^\D+/g, '')
                                                                        : ''
                                                                }
                                                                onCopy={() => this.showSuccessMessage(t('balance.copyBankAccountSuccess'))}
                                                            >
                                                                <img
                                                                    src='/images/ico_copy.svg'
                                                                    className='card-icon'
                                                                    alt={t('balance.copyBankAccount')}
                                                                />
                                                            </CopyToClipboard>
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    </BlockUi>
                                </Card>
                            </DivContainer>
                        ) : null}
                        {(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
                            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
                            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
                            this.authService.getProfile().helpdeskUserRole === 'HOTLINE') ? (
                            <DivContainer colClass='col-12 two-step-auth-container'>
                                <DivContainer colClass='row'>
                                    <DivContainer colClass='col-12'>
                                        <Card header={this.renderTwoStepAuthHeader()}>
                                            <BlockUi
                                                tag='div'
                                                blocking={this.state.profileInfoLoading}
                                                loader={this.loader}
                                                loaderType='small-loader'
                                                horizontal
                                            >
                                                <div className='row profile-notifications'>
                                                    <div className='profile-notification-subheader'>
                                                        <span className='header-notification'> {t('profile.two-part-login-header')}</span>
                                                    </div>
                                                    <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                        <div className='row' key={`2-step-auth-phone`}>
                                                            <InputTextComponent
                                                                id={`$2stepAuthPhone`}
                                                                name='phone'
                                                                label={t('profile.notificationPhoneNumber')}
                                                                colClass='col-12'
                                                                value={this.state.profileInfo.phone}
                                                                stateField={`profileInfo.phone`}
                                                                viewMode={this.state.viewMode}
                                                                showLabel={true}
                                                                validator={this.validator}
                                                                validators=''
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                                                        <div className='row' key={`2-step-auth-phone`}>
                                                            <InputTextComponent
                                                                id={`$2stepAuthEmail`}
                                                                name='email'
                                                                label={t('profile.notificationEmail')}
                                                                colClass='col-12'
                                                                value={this.state.profileInfo.email}
                                                                stateField={`profileInfo.phone`}
                                                                viewMode={this.state.viewMode}
                                                                showLabel={true}
                                                                validator={this.validator}
                                                                validators=''
                                                            />
                                                        </div>
                                                    </div>
                                                    <InputRadioButtonComponent
                                                        id={`twoStepAuthChosen-type`}
                                                        name='type'
                                                        colClass='col-12 card-manage-limits'
                                                        options={this.state.twoStepAuthPaths}
                                                        value={this.state.twoStepAuthChosen}
                                                        valueLabel='label'
                                                        labelOnRight
                                                        itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                                                        onChange={this.handleChange}
                                                        showLabel={true}
                                                        validator={this.validator}
                                                        validators='required'
                                                        label='Wykorzystaj'
                                                        viewMode={'VIEW'}
                                                        rendered={this.props.viewMode === 'VIEW'}
                                                        valueKey='enumValue'
                                                        stateField={`twoStepAuthChosen`}
                                                    />
                                                </div>
                                                <span style={{ margin: '5px' }}></span>
                                                <div className='row profile-notifications'>
                                                    <div className='profile-notification-subheader'>
                                                        <span className='header-notification'> {t('profile.trustedDevicesHeader')}</span>
                                                    </div>
                                                    <div className='col-xl-8 col-lg-8 col-md-8 col-sm-12'>
                                                        <label className='p-label'>{'Urządzenie'}</label>
                                                        {this.state.trustedDevices && this.state.trustedDevices.length > 0
                                                            ? this.state.trustedDevices?.map((trustedDevice, index) => {
                                                                return (
                                                                    <div className='row' key={`trustedDevice-${index}-${trustedDevice?.deviceIdent}`}>
                                                                        <InputTextComponent
                                                                            id={`${index}-trustedDevice`}
                                                                            name='trustedDevice'
                                                                            colClass='col-12'
                                                                            value={trustedDevice?.deviceIdent + ' (' + trustedDevice?.deviceName + ')'}
                                                                            stateField={`trustedDevice[${index}]`}
                                                                            validator={this.validator}
                                                                            validators=''
                                                                        />
                                                                    </div>
                                                                );
                                                            }) : null
                                                        }
                                                    </div>
                                                </div>
                                            </BlockUi>
                                        </Card>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                        ) : null}
                        {/* <DivContainer colClass='col-12'>
                            <Card header={this.renderNotificationHeader()}>
                                <div className='row profile '>
                                    <span className='notification-span col-12'>{t('notification.description')}</span>
                                </div>
                                <div className='row profile m-0'>
                                    <InputSwitchButtonComponent
                                        label={t('notification.label')}
                                        colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                        labelOnLeft
                                        id='notificationEnabled'
                                        name='notificationEnabled'
                                        value={this.state.element.notificationEnabled}
                                        options={[true, false]}
                                        onChange={this.handleChange}
                                        valueLabel=''
                                        valueKey=''
                                        onAfterStateChange={() => this.notifactionEnabledChange()}
                                        validator={this.validator}
                                        validators=''
                                    />
                                </div>
                            </Card>
                        </DivContainer> */}
                    </DivContainer>
                </DivContainer>
                {this.user && (
                    (this.user.agreementSapRole === 'FLOTA' && this.isUserHasPermission('PERMISSION_EDIT_PROFILE')) ||
                    this.user.agreementSapRole === 'HURT' ||
                    this.user.agreementSapRole === 'FRANCZYZA' ||
                    this.user.agreementSapRole === 'HURT EPT'
                ) && (
                        <DivContainer colClass='col-12 history-link-container'>
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <Card header={this.renderHistoryHeader()}>
                                        <HistoryListContainer
                                            month={this.state.month}
                                            userAgreementMap={this.state.userAgreementMapForHistory}
                                            disableSelection={true}
                                            handleError={() => this.showErrorMessage('Wystąpił błąd systemu. Nie udało się pobrać listy.')}
                                            blockUi={this.blockUi}
                                            unblockUi={this.unblockUi}
                                            showMessage={this.showMessage}
                                            embedded
                                            _isMounted={this._isMounted}
                                        />
                                    </Card>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    )
                }
            </React.Fragment>
        );
    }
    handleChangePasswordDialogShow() {
        this.setState({ changePasswordVisibile: true });
    }
    handleChangePasswordDialogHide(callback) {
        this.setState({ changePasswordVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handlePartnerDialogShow(dialogType) {
        this.setState({ partnerApiAccessDialogVisibile: true, apiAccessDialogType: dialogType });
    }

    handlePartnerApiAccessDialogHide(callback) {
        this.setState({ partnerApiAccessDialogVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    viewApiAccessPassword(res){
        this.setState({apiAccessPassword: res.password, partnerApiAccessDialogVisibile: false })
    }

    handleTrustedDevicesDialogShow() {
        this.setState({ trustedDevicesDialogVisible: true });
    }
    handleTrustedDevicesDialogHide(e, callback) {
        this.setState({ trustedDevicesDialogVisible: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleChangeTwoStageLoginSettingsDialogShow() {
        this.setState({ twoStageLoginSettingsDialog: true });
    }
    handleChangeTwoStageLoginSettingsDialogHide(e, callback) {
        this.setState({ twoStageLoginSettingsDialog: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleOpenDialog(e, type) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ dialogVisibile: true, dialogNotificationType: type });
    }
    handleCloseDialog(id, callback) {
        this.setState({ dialogVisibile: false, twoStageLoginSettingsDialog: false, trustedDevicesDialogVisible: false }, () => {
            if (callback) {
                callback();
            }
        });
    }
}

export default withTranslation()(ProfileContainer);
